import { Component, Input } from '@angular/core';

@Component({
  selector: 'hub-loading-spinner',
  templateUrl: './loading-spinner.html',
  styleUrls: ['./loading-spinner.scss']
})
export class LoadingSpinnerComponent {}
